import React from 'react'
import { FormattedMessage } from 'react-intl'
import { ReactComponent as Delete } from '@mike/mike-shared-frontend/media/icons/Delete'
import { ButtonProps as MuiButtonProps } from '@mui/material/Button'
import messages from '../../shared/messages'

import { iconSecondaryStyle, StyledIconButton } from './iconStyles'

const DeleteButton = (buttonProps: MuiButtonProps) => {
  return (
    <StyledIconButton {...buttonProps}>
      <Delete className={iconSecondaryStyle(buttonProps.disabled)} />
      <FormattedMessage id={messages.delete.id} />
    </StyledIconButton>
  )
}

export default DeleteButton
